const productsWithSuppliersQuery = `query GetProductsWithSuppliers($productKrns: [String!]!, $productCategory: ProductCategory!) {
    productsWithSuppliers(productKrns: $productKrns, productCategory: $productCategory) {
        products {
            affiliateUrl
            correspondingMoneyViewExternalId
            creationDateTime
            customAttributes {
                description
                value
            }
            eventInformation {
                id
                category
                name
                definition
                duration
            }
            dataProviderKrn
            description
            entityType
            externalId
            id
            insuranceCardUrl
            krn
            lastModifiedBy
            lastModifiedDateTime
            name
            orderType
            productCategory
            productIncentives {
                productIncentiveDetailsKrn
            }
            productSupplierId
            productType
            productTypeKrn
            refKey
            sellingPoints {
                description
                value
            }
            state
            termsAndConditionsUrl
            testScores {
                score
                source
            }
            version
            orderType
        }
        productIncentiveDetails {
            krn
            label
            productIncentiveType
        }
        suppliers {
            about
            addresses {
                addressType
                city
                country
                houseNumber
                houseNumberAddition
                id
                postalCode
                street
            }
            advantages {
                clientName
                description
                productCategory
            }
            creationDateTime
            customAttributes {
                description
                value
            }
            disadvantages {
                clientName
                description
                productCategory
            }
            entityType
            externalIds {
                externalSupplierId
                providerKrn
            }
            features {
                name
                productCategory
                value
            }
            howItWorks {
                clientName
                productCategory
                typeName
                value
            }
            id
            informationContacts {
                emailAddress
                id
                phoneNumber
                replyNumber
                type
            }
            krn
            lastModifiedBy
            lastModifiedDateTime
            legalName
            name
            nameLogoUrl
            porCompany
            refKey
            sellingPoints {
                clientName
                description
                orderType
                productCategory
                sellingPointType
                value
            }
            state
            sustainabilityScore {
                score
                source
            }
            taskDivisions {
                clientName
                creationDateTime
                entityType
                id
                lastModifiedBy
                lastModifiedDateTime
                name
                productCategory
                value
                version
            }
            version
        }
        productCommission
        {
         krn
         renewalCommissionInstallmentAmountPartner
         commissionConfigs {
            startDate
            numberOfMonths
            commissionNetPremiumFactorPerBillablePerson
            commissionNetPremiumFactor
            commissionAmountPerMonth
            commissionAmountPerBillablePerson
            commissionAmountFixedFee
            renewalCommissionInstallmentNumberOfMonths
            renewalCommissionInstallmentAmountLink
        }
        commissionShareConfigs {
            startDate
            partnerFixedAmount
            partnerCommissionFactor
            subPartnerCommissions {
                partnerCommissionFactor
                partnerFixedAmount
                partnerName
            }
        }
    }

    }
}`;

export default productsWithSuppliersQuery;
